var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirgo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Virgo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Virgo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,2 C3.791,2 2,3.791 2,6 L2,15 L4,15 L4,6 C4,4.897 4.897,4 6,4 C7.103,4 8,4.897 8,6 L10,6 C10,3.791 8.209,2 6,2",
    id: "Candy-Cane",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C9.791,2 8,3.791 8,6 L8,15 L10,15 L10,6 C10,4.897 10.897,4 12,4 C13.103,4 14,4.897 14,6 L14,22 L16,22 L16,6 C16,3.791 14.209,2 12,2",
    id: "Tail",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,11 C15.791,11 14,12.791 14,15 L16,15 C16,13.897 16.897,13 18,13 C19.103,13 20,13.897 20,15 C20,16.103 19.103,17 18,17 L18,19 C20.209,19 22,17.209 22,15 C22,12.791 20.209,11 18,11",
    id: "Loop",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Tip",
    fill: "#000000",
    points: "12 19 18 19 18 17 12 17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirgo);
export default __webpack_public_path__ + "static/media/virgo.aef4647385a20fc53398184411a3169c.svg";
export { ForwardRef as ReactComponent };